<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<small *ngIf="value && fromCurrency && fromCurrency.code !== 'EUR'">
  {{ value / fromCurrency?.exchange_rate | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
</small>
<small *ngIf="!value"> {{ 0 | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }} </small>
